import { createFileRoute } from "@tanstack/react-router";
import type { EquipmentModelId } from "@brewbase/db/types";
import { useFleetSidebar } from "@/features/brewcontrol/use-fleet-sidebar";
import { CalibrationTargetsPage } from "@/features/brewcontrol/calibration-targets-page";

export const Route = createFileRoute("/brewcontrol/wirings/$modelId/calibration")(
  { component: CalibrationRoute },
);

function CalibrationRoute() {
  useFleetSidebar();
  const { modelId } = Route.useParams();
  return (
    <CalibrationTargetsPage
      key={modelId}
      equipmentModelId={Number(modelId) as EquipmentModelId}
    />
  );
}
